/* eslint-disable no-console */
function openBlock(element){
    if(element != null && !element.classList.contains("opened")){
            var sectionHeight = element.scrollHeight;
            element.style.height = sectionHeight + 'px';
            element.style.margin = "10px 0 40px 0";
            element.addEventListener('transitionend', function(e) {
                element.removeEventListener('transitionend', arguments.callee);
                element.style.height = "auto";
                element.classList.add("opened");
            });
    }
}
function closeBlock(element){
    var sectionHeight = element.scrollHeight;
    var elementTransition = element.style.transition;
    element.style.transition = '';
    requestAnimationFrame(function() {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        requestAnimationFrame(function() {
            element.style.height = 0 + 'px';
            element.style.margin = "0";
        });
    });
    element.classList.remove("opened");
}

function toggleOpenBlock(buttonElements, buttonElement) {
    var sameGroupElements = document.getElementsByClassName(buttonElement.dataset.group);
    for(var i=0; i<sameGroupElements.length; i++){
    	if(sameGroupElements[i] !== document.getElementsByClassName(buttonElement.dataset.block)[0]){
    		closeBlock(sameGroupElements[i]);
    	}
    }
    var thisBlock = document.getElementsByClassName(buttonElement.dataset.block)[0];
    if(thisBlock != null) {
        if(thisBlock.classList.contains('opened')){
            closeBlock(thisBlock);
        }else{
            openBlock(thisBlock);
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    var url = window.location.href;
    var anchor = "";
    if(url.indexOf("#") != -1){
        anchor = url.substring(url.indexOf("#")+1)
    }

	var buttonElements = document.querySelectorAll('.exe-more-info-button');
	if (buttonElements) {
		buttonElements.forEach(function (buttonElement) {
			buttonElement.addEventListener('click', function () {
                toggleOpenBlock(buttonElements, buttonElement);
			});
            if(buttonElement.dataset.anchor != "" && buttonElement.dataset.anchor == anchor){
                toggleOpenBlock(buttonElements, buttonElement);
            }
		});

	}
});
/* eslint-enable no-console */
